import { EntityState } from "@ngrx/entity";
import { StoryStepEntity } from '../entities';

export interface StoryStepState  extends EntityState<StoryStepEntity> {
    loading:boolean,
    loaded:boolean,
    createdTagId: number,
    stepSelectedId: number
}